import React, { useRef } from 'react';
import { View, Animated, StatusBar, Dimensions } from 'react-native';
import { connect } from 'react-redux';

import { isAndroid, settingsLine } from '@helpers';
import { GridBox, ElementBox, width, scale } from '@components/frame';
import ColorWrapper from '@styles/colors';

import useStatusBar from '@components/common/useStatusBar';
import AnimatedHeader from '@components/common/AnimatedHeader';

import Header from './components/header';

import List from './components/list';

const Profile = (props) => {
  const { C } = props;
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scrollRef = useRef(null);

  const startFrom = 50;

  const scrollListener = ({ nativeEvent }) => {
    const {
      contentOffset: { y },
    } = nativeEvent;
    if (isAndroid) {
      if (y > scale(startFrom)) {
        if (!headerActive) {
          setHeaderActive(true);
          StatusBar.setBackgroundColor(C('Background / Light / System'));
        }
      } else {
        if (headerActive) {
          setHeaderActive(false);
          StatusBar.setBackgroundColor(C('Background/Light/Detail'));
        }
      }
    }
  };

  return (
    <ElementBox>
      <AnimatedHeader
        {...{
          fadeAnim,
          C,
          text: 'Search',
          scrollRef,
          startFrom: startFrom,
        }}
      />
      <View style={{ width: '100%', height: '100%' }}>
        <Animated.ScrollView
          scrollEventThrottle={16}
          ref={scrollRef}
          onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: fadeAnim } } }], {
            useNativeDriver: true,
            listener: scrollListener,
          })}
          contentContainerStyle={{
            backgroundColor: C('Background / Light / Detail'),
            width: '100%',
            alignItems: 'center',
          }}
        >
          <View style={{ width, height: '100%' }}>
            <Header {...{ C }} />
            <List {...{ ...props, tabs: settingsLine }} />
          </View>
        </Animated.ScrollView>
      </View>
    </ElementBox>
  );
};

const SearchWrapper = (props) => {
  const { C } = props;

  const bg = C('Background / Light / Detail');

  useStatusBar({ background: bg, C });

  return [
    <GridBox
      key="mainBox"
      {...{
        backgroundColor: bg,
        headerOffset: true,
        sliderOffset: false,
        customWidth: Dimensions.get('window').width,
      }}
    >
      <Profile {...props} />
    </GridBox>,
  ];
};

export default connect(null, {})(ColorWrapper(SearchWrapper));
